module.exports = __webpack_public_path__ + "nthumbtack.svg";